module.exports = __webpack_public_path__ + "static/media/ios-arrow-round-up.14aa8e97.svg";